import type { LucideIcon } from 'lucide-react';

interface Props {
    icon: LucideIcon;
    label: string;
    value: string;
    sub?: string;
    accent?: 'blue' | 'amber';
    onClick?: () => void;
}

export function StatTile({ icon: Icon, label, value, sub, accent = 'blue', onClick }: Props) {
    const accentCls = accent === 'amber' ? 'text-amber-600 bg-amber-50' : 'text-blue-600 bg-blue-50';
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={!onClick}
            className="flex-1 text-left rounded-2xl border border-gray-200 bg-white p-4 disabled:cursor-default enabled:hover:border-gray-300 enabled:active:scale-[0.99] transition"
        >
            <div className={`inline-flex h-9 w-9 items-center justify-center rounded-lg ${accentCls}`}>
                <Icon className="h-5 w-5" />
            </div>
            <p className="mt-3 text-2xl font-bold text-gray-900 leading-none">{value}</p>
            <p className="mt-1 text-sm font-medium text-gray-700">{label}</p>
            {sub && <p className="text-xs text-gray-400">{sub}</p>}
        </button>
    );
}
